import Cookies from "js-cookie";

import { actions } from "@/store/searchSlice";

export const getCityAndZipcodeCookies = () => {
  const city = Cookies.get("n32UserPrimaryCity");
  const zipCode = Cookies.get("n32UserPrimaryZip");
  return { city, zipCode };
};

export const setCityAndZipcodeCookies = (city: string | undefined, zipCode: string | undefined) => {
  Cookies.set("n32UserPrimaryCity", city ?? "Cary", { expires: 1 });
  Cookies.set("n32UserPrimaryZip", zipCode?.slice(0, 5) ?? "27513", { expires: 1 });
};

export const removeCityAndZipcodeCookies = () => {
  Cookies.remove("n32UserPrimaryCity");
  Cookies.remove("n32UserPrimaryZip");
  removeRegionIdCookie();
};

export const removePrimaryAddressDetails = (address: Account.Addresses.Address) => {
  const { city, zipCode } = getCityAndZipcodeCookies();
  if (
    city?.toLowerCase() === address.City.toLowerCase() &&
    zipCode?.slice(0, 5) === address.PostalCD.slice(0, 5) &&
    address.IsPrimary
  ) {
    removeCityAndZipcodeCookies();
  }
};

export const getRegionIdCookie = () => {
  const regionCd = Cookies.get("n32UserPrimaryRegionId");
  return regionCd;
};

export const setRegionIdCookie = (regionId: number | undefined) => {
  Cookies.set("n32UserPrimaryRegionId", typeof regionId !== "undefined" ? String(regionId) : "27513", { expires: 1 });
};

export const removeRegionIdCookie = () => {
  Cookies.remove("n32UserPrimaryRegionId");
};

export const dispatchShippingDetails = (dispatch: any, zipCode: string | undefined, regionCd: string | undefined) => {
  dispatch(actions.setShippingZipCode(zipCode?.slice(0, 5) ?? "27513"));
  dispatch(actions.setShippingRegionId(regionCd ?? "NC"));
};
